import { PlusInSquareIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Pagination, SearchInput } from "ui";

import { AnnouncementsTable, AnnouncementModal } from "../../components";
import { AnnouncementsHistoryListItem } from "../../content.types";
import { useAnnouncementsHistoryList } from "../../hooks";

import styles from "./Announcements.module.scss";

const Announcements = () => {
  const {
    value: isAnnouncementModalOpen,
    setTrue: openAnnouncementModal,
    setFalse: closeAnnouncementModal
  } = useBoolean();

  const [editableAnnouncement, setEditableAnnouncement] =
    useState<AnnouncementsHistoryListItem | null>(null);

  const {
    announcementsHistory,
    totalItems,
    isLoading,
    searchValue,
    page,
    setSearchValue,
    setPage
  } = useAnnouncementsHistoryList();

  useEffect(() => {
    if (editableAnnouncement) {
      openAnnouncementModal();
    }
  }, [editableAnnouncement]);

  return (
    <div className={styles.announcements}>
      <div className={styles.announcements_header}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={t("Search...")}
        />
        <Button icon={<PlusInSquareIcon />} onClick={openAnnouncementModal}>
          {t("New Announcement")}
        </Button>
      </div>

      <div className={styles.announcements_table}>
        <AnnouncementsTable
          announcementsHistory={announcementsHistory ?? []}
          isLoading={isLoading}
          canUpdateLastAnnouncement={!searchValue}
          setEditableAnnouncement={setEditableAnnouncement}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />

      <AnnouncementModal
        isOpen={isAnnouncementModalOpen}
        onClose={() => {
          closeAnnouncementModal();
          setEditableAnnouncement(null);
        }}
        editableAnnouncement={editableAnnouncement}
      />
    </div>
  );
};

export default Announcements;
